import { useStyles } from "./styles";

export const Plus = () => {
  const styles = useStyles();

  return (
    <div style={styles.container}>
      <span style={styles.icon}>+</span>
    </div>
  );
};
